/* eslint-disable no-restricted-imports */
import { DateTime } from "@bps/date-time";
import { DatePicker as CoreDatePicker, DatePickerProps } from "@bps/fluent-ui";

export const DatePicker: React.FunctionComponent<DatePickerProps> = ({
  calendarProps,
  ...props
}) => (
  <CoreDatePicker
    {...props}
    calendarProps={{
      today: DateTime.jsDateNow(),
      ...calendarProps
    }}
  />
);
